import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthProvider/AuthProvider";
import { useState } from "react";

const Login = () => {
  const [error,setError]=useState('')
  const { logIn } = useContext(AuthContext);
  const navigate=useNavigate();

  const handleLogin = (event) => {
    event.preventDeafult();
    const form = event.target;
    const email = form.email.value;
    const password = form.password.value;
    console.log(email, password,event);
    logIn(email, password)
            .then(result => {
                const user = result.user;
                console.log(user);
                form.reset();
                navigate('/home')
                setError('')
            })
            .catch(error=>{
              console.log(error);
              setError(error.message)
            })
  };
  return (
    <div>
      <div className=" w-9/12 mx-auto mt-14">
        <div className="w-full max-w-md p-8 space-y-3 rounded-xl bg-gray-900 text-gray-100">
          <h1 className="text-3xl font-bold text-center">Login</h1>
          <form
            onSubmit={handleLogin}
            className="space-y-6 ng-untouched ng-pristine ng-valid"
          >
            <div className="space-y-1 text-sm">
              <label htmlFor="username" className="block dark:text-gray-400">
                Email
              </label>
              <input
                type="email"
                name="email"
                id="username"
                placeholder="Username"
                className="w-full px-4 py-3 rounded-md dark:border-gray-700 dark:bg-gray-900  text-gray-700 focus:dark:border-violet-400"
                required
              />
            </div>
            <div className="space-y-1 text-sm">
              <label htmlFor="password" className="block dark:text-gray-400">
                Password
              </label>
              <input
                type="password"
                name="password"
                id="password"
                placeholder="Password"
                className="w-full px-4 py-3 rounded-md dark:border-gray-700 dark:bg-gray-900 text-gray-700 focus:dark:border-violet-400"
                required
              />
              <div className="flex justify-end text-xs dark:text-gray-400">
                <Link rel="noopener noreferrer" to="#">
                  Forgot Password?
                </Link>
              </div>
             <p className="text-red-200">{error}</p>
            </div>
            <button
              type="submit"
              className="block w-full p-3 text-center rounded-md bg-violet-500 dark:text-gray-100 hover:bg-blue-600"
            >
              Sign in
            </button>
          </form>
          <div className="flex items-center pt-4 space-x-1">
            <div className="flex-1 h-px sm:w-16 dark:bg-gray-700"></div>
            <div className="flex-1 h-px sm:w-16 dark:bg-gray-700"></div>
          </div>

          <p className="text-xs text-center sm:px-6 dark:text-gray-400">
            Don't have an account?
            <Link
              rel="noopener noreferrer"
              to="/signup"
              className="underline dark:text-gray-100"
            >
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
